import { InjectionToken } from "@angular/core";

/**
 * interfaces
 */
import { 
    IAuthGetNewTokenApi,
    IAuthLoginApi,
    IAuthLogoutApi,
    IAuthSessionManagementApi,
    IAuthForgotPasswordApi,
    IAuthResetPasswordApi,
    IAuthCheckResetTokenApi
} from "../interfaces";

/**
 * Injection token for authentication login API
 * @constant {InjectionToken<IAuthLoginApi>} AUTH_API_LOGIN
 * @description Token used to inject authentication login API services
 */

export const AUTH_API_LOGIN = new InjectionToken<IAuthLoginApi>('AUTH_API_LOGIN');

/**
 * Injection token for authentication logout API
 * @constant {InjectionToken<IAuthLogoutApi>} AUTH_API_LOGOUT
 * @description Token used to inject authentication logout API services
 */
export const AUTH_API_LOGOUT = new InjectionToken<IAuthLogoutApi>('AUTH_API_LOGOUT');

/**
 * Injection token for authentication get new token API
 * @constant {InjectionToken<IAuthGetNewTokenApi>} AUTH_API_GET_NEW_TOKEN
 * @description Token used to inject authentication get new token API services
 */
export const AUTH_API_GET_NEW_TOKEN = new InjectionToken<IAuthGetNewTokenApi>('AUTH_API_GET_NEW_TOKEN');

/**
 * Injection token for authentication session management API
 * @constant {InjectionToken<IAuthSessionManagementApi>} AUTH_API_SESSION_MANAGEMENT
 * @description Token used to inject authentication session management API services
 */
export const AUTH_API_SESSION_MANAGEMENT = new InjectionToken<IAuthSessionManagementApi>('AUTH_API_SESSION_MANAGEMENT');
/**
 * Injection token for forgot password API service
 * @constant {InjectionToken<IAuthForgotPasswordApi>} AUTH_API_FORGOT_PASSWORD
 */
export const AUTH_API_FORGOT_PASSWORD = new InjectionToken<IAuthForgotPasswordApi>('AUTH_API_FORGOT_PASSWORD');

/**
 * Injection token for reset password API service
 * @constant {InjectionToken<IAuthResetPasswordApi>} AUTH_API_RESET_PASSWORD
 */
export const AUTH_API_RESET_PASSWORD = new InjectionToken<IAuthResetPasswordApi>('AUTH_API_RESET_PASSWORD');

/**
 * Injection token for check reset token API service
 * @constant {InjectionToken<IAuthCheckResetTokenApi>} AUTH_API_CHECK_RESET_TOKEN
 */
export const AUTH_API_CHECK_RESET_TOKEN = new InjectionToken<IAuthCheckResetTokenApi>('AUTH_API_CHECK_RESET_TOKEN');

